export default defineAppConfig({
  app: {
    allowInactiveUsers: true,
    isStagedoos: true,
  },
  theme: {
    cssVariables: {
      'color-theme-footer-background': '#02B2FE',
    },
  },
  nui: {
    // Note: changed in latest tairo version.
    defaultShapes: {
      button: 'full',
    },
  },
})
